import { createFileRoute } from '@tanstack/react-router'
import { Stack } from '@astryxdesign/core/Stack'
import { Card } from '@astryxdesign/core/Card'
import { Text } from '@astryxdesign/core/Text'
import { useDays, useItems, usePlaces, useTrip, useMe } from '#/lib/hooks'
import { isAdmin } from '#/lib/types'

export const Route = createFileRoute('/manage/itinerary')({ component: ManageItinerary })

/**
 * Deliberately not built yet. The itinerary is authored in
 * scripts/trips/<slug>.cjs and seeded, which is the right tool while a trip is
 * being planned in one sitting. Editing it in the app is a different job —
 * reordering days, moving an activity between stops, resolving two people
 * editing the same day — and guessing at it now would mean throwing it away.
 */
function ManageItinerary() {
  const me = useMe()
  const trip = useTrip()
  const places = usePlaces(trip?.id)
  const items = useItems(trip?.id)
  const days = useDays(trip?.id)

  if (me && !isAdmin(me.role)) return <Text type="supporting">Admins only.</Text>

  return (
    <Stack direction="vertical" gap={4}>
      <Stack direction="vertical" gap={0}>
        <Text type="display-3" display="block">Itinerary</Text>
        <Text type="supporting">Where the trip gets built. Not editable here yet.</Text>
      </Stack>

      <Card>
        <Stack direction="vertical" gap={2}>
          <Text type="label" color="secondary">{trip?.name ?? 'No trip'}</Text>
          <Text type="supporting">
            {days.length} days · {places.length} stops · {items.length} activities
          </Text>
          <Text type="supporting">
            {items.filter((i) => i.ticket_status === 'todo').length} still need tickets
          </Text>
        </Stack>
      </Card>

      <Card variant="muted">
        <Stack direction="vertical" gap={2}>
          <Text weight="medium">Editing here is not built yet</Text>
          <Text type="supporting">
            The itinerary is authored in <Text type="code">scripts/trips/</Text> and
            seeded, which suits planning a trip in one sitting. Editing in the app
            is a different problem — reordering days, moving an activity between
            stops, two people editing the same day at once — and it is worth
            building once, properly, rather than guessing at it now.
          </Text>
        </Stack>
      </Card>
    </Stack>
  )
}
